require('./lbFareRulesModal.scss');

const lbFareRulesModal = angular.module('app.lbFareRulesModal', []);

lbFareRulesModal.component('lbFareRulesModal', {
  controllerAs: 'vm',
  controller: ['lbModalService', controller],
  template: require('./lbFareRulesModal.html')
});

function controller(lbModalService) {
  let vm = this;

  const params = lbModalService.params();
  const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

  vm.carrierName = params.trip.CarrierName;
  vm.rulesType = params.fareRules.Type;
  vm.fareRulesText = params.fareRules.Data;

  if (vm.rulesType === 'ExternalUrl') {
    vm.fareRulesText = vm.fareRulesText.replace(urlReg, replaceLink);
  }

  function replaceLink(str) {
    return '<a href="' + str + '" target="_blank" rel="noreferrer noopener">' + 'Click here to view fare rules' + '</a>';
  }

  vm.close = lbModalService.resolve;
}

export default lbFareRulesModal;



// WEBPACK FOOTER //
// ./src/components/lbFareRulesModal/lbFareRulesModal.js